import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../core/services/auth.service';
import { User } from './../../core/models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { JWTService } from '../../core/services/jwt.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  loginForm: FormGroup;
  error: string = '';
  hint: string = '';
  show: boolean = false;
  showConfirm: boolean = false;
  accessToken: any = {};
  qParam: any = [];
  email: string = '';
  getuser: any = [];
  prevPassword: string = '';
  confPassword: string = '';

  constructor(
    private authService: AuthService,
    private jwt: JWTService,
    private router: Router
  ) {
    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20),
      ]),
      confirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20),
      ]),
    });
  }

  ngOnInit(): void {
    const UserDetails: any = this.jwt.getDecodedToken();
    this.getuser = UserDetails.userid;
    // this.userDetails()
  }
  onChange() {
    this.error = '';
  }
  get f() {
    return this.loginForm.controls;
  }
  onSubmit() {
    if (this.loginForm.valid) {
      if (
        this.loginForm.value.password === this.loginForm.value.confirmPassword
      ) {
        this.qParam['email'] = this.getuser;
        this.qParam['password'] = this.loginForm.value.password;
        this.authService
          .changePassword(this.qParam['email'], this.qParam['password'])
          .subscribe(
            (result: any) => {
              if (result.Response == 'Data Updated') {
                this.hint = 'Password Updated Successfully';
                this.prevPassword = '';
                this.confPassword = '';
                this.router.navigate(['/']);
              } else {
                this.error = 'Password not updated';
              }
            },
            (error: any) => {
              this.error = 'Invalid Email..Please try again.';
            }
          );
      } else {
        this.error = 'Passwords are not matching!';
      }
    } else {
      this.error = 'Please enter a valid password';
    }
  }
  toggleShow() {
    this.show = !this.show;
  }
  toggleConfirmShow() {
    this.showConfirm = !this.showConfirm;
  }
  userDetails() {
    this.accessToken = this.authService.getCurrentUser();
    this.authService
      .getUserDetails(this.accessToken)
      .subscribe((result: any) => {});
  }
}
